/* pv-extras.js — Productsverse store extras (no Dawn core files edited)
   1. Cart drawer: free-delivery progress bar + "complete your order" upsell
   2. Product cards: sale badge shows "-X% OFF"                              */
(function () {
  var cfgEl = document.getElementById('pv-config');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) {}
  var moneyFormat = cfg.moneyFormat || 'Rs.{{amount}}';

  function money(cents) {
    var n = cents / 100;
    var two = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var none = Math.round(n).toLocaleString('en-US');
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, none)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two)
      .replace(/\{\{\s*amount\s*\}\}/, two)
      .replace(/<[^>]*>/g, '');
  }

  /* ---------- Cart drawer add-ons ---------- */
  var decorating = false;
  function getCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function decorate(cart) {
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (!inner || !cart) return;
    decorating = true;
    inner.querySelectorAll('.pv-freeship, .pv-upsell').forEach(function (n) { n.remove(); });

    if (cart.item_count > 0 && cfg.freeShip > 0) {
      var remaining = cfg.freeShip - cart.total_price;
      var pct = Math.min(100, Math.round(cart.total_price * 100 / cfg.freeShip));
      var bar = document.createElement('div');
      bar.className = 'pv-freeship' + (remaining <= 0 ? ' is-done' : '');
      bar.innerHTML = '<p class="pv-freeship__msg">' +
        (remaining > 0
          ? 'You’re <strong>' + money(remaining) + '</strong> away from <strong>FREE delivery</strong>'
          : '🎉 You’ve unlocked <strong>FREE delivery</strong>') +
        '</p><div class="pv-freeship__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>';
      var header = inner.querySelector('.drawer__header');
      if (header) header.insertAdjacentElement('afterend', bar);
    }

    var tpl = document.getElementById('pv-upsell-tpl');
    var footer = inner.querySelector('.drawer__footer');
    if (tpl && footer && cart.item_count > 0) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = true; });
      var picks = Array.prototype.filter.call(tpl.content.querySelectorAll('.pv-upsell__item'), function (el) {
        return !inCart[el.getAttribute('data-product-id')];
      }).slice(0, 3);
      if (picks.length) {
        var box = document.createElement('div');
        box.className = 'pv-upsell';
        box.innerHTML = '<p class="pv-upsell__title"></p><div class="pv-upsell__list"></div>';
        box.querySelector('.pv-upsell__title').textContent = cfg.upsellHeading || 'Complete your order';
        var list = box.querySelector('.pv-upsell__list');
        picks.forEach(function (el) { list.appendChild(el.cloneNode(true)); });
        footer.insertAdjacentElement('afterbegin', box);
      }
    }
    setTimeout(function () { decorating = false; }, 0);
  }

  var timer = null;
  function refreshSoon() {
    clearTimeout(timer);
    timer = setTimeout(function () { getCart().then(decorate).catch(function () {}); }, 120);
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () { if (!decorating) refreshSoon(); })
      .observe(drawer, { childList: true, subtree: true });
    refreshSoon();
  }

  function refreshDrawerSections() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        if (sections['cart-drawer']) {
          var fresh = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('.drawer__inner');
          var current = document.querySelector('cart-drawer .drawer__inner');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          var drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.classList.remove('is-empty');
        }
        if (sections['cart-icon-bubble']) {
          var bubble = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          var target = document.getElementById('cart-icon-bubble');
          if (bubble && target) target.innerHTML = bubble.innerHTML;
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pv-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-pv-upsell-add'), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(refreshDrawerSections)
      .then(refreshSoon)
      .catch(function () { btn.disabled = false; btn.textContent = '+ Add'; });
  });

  /* ---------- "-X% OFF" sale badges ---------- */
  function num(t) { var m = (t || '').match(/\d[\d,]*(\.\d+)?/); return m ? parseFloat(m[0].replace(/,/g, '')) : 0; }
  function badges(root) {
    if (!cfg.badgePercent) return;
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.dataset.pvBadge) return;
      var was = card.querySelector('.price--on-sale s.price-item--regular');
      var now = card.querySelector('.price--on-sale .price-item--sale');
      if (!was || !now) return;
      var a = num(was.textContent), b = num(now.textContent);
      if (!(a > b && b > 0)) return;
      var pct = Math.floor((a - b) * 100 / a);
      if (pct < 1) return;
      card.querySelectorAll('.card__badge .badge').forEach(function (el) {
        if (!/sold/i.test(el.textContent)) el.textContent = '-' + pct + '% OFF';
      });
      card.dataset.pvBadge = '1';
    });
  }

  var badgeTimer = null;
  function init() {
    watchDrawer();
    badges();
    new MutationObserver(function () { clearTimeout(badgeTimer); badgeTimer = setTimeout(badges, 150); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
